export default __webpack_public_path__ + "static/media/icon_close_toast.0a4cfb5c.svg";